export default __webpack_public_path__ + "static/logo-107ef010eab9629bd10534d2bf24cfec.png";